import { AppParts } from "../modules/AppParts";

const AppEvents = {
    TimeEntityEditorFields_ResourceFilterUpdated: AppParts.TimeTracking.TimeEntities.EditorFields + ':ResourceFilterUpdated',
    Notification_Published : 'Notification:Published'
};

export default AppEvents
